import { useDragLayer } from 'react-dnd';
import { PHASE_DRAG_TYPE, type PhaseDragItem } from '../../../lib/dndTypes';

export function PhaseDragLayer() {
  const { isDragging, item, currentOffset, itemType } = useDragLayer((m) => ({
    isDragging: m.isDragging(),
    item: m.getItem() as PhaseDragItem | null,
    currentOffset: m.getSourceClientOffset(),
    itemType: m.getItemType(),
  }));

  if (!isDragging || itemType !== PHASE_DRAG_TYPE || !item || !currentOffset) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-50">
      <div
        className="absolute"
        style={{ transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)` }}
      >
        <div className="flex gap-1">
          {Array.from({ length: Math.max(1, item.durationDays) }).map((_, i) => (
            <div
              key={i}
              data-ghost-day
              className="w-[120px] h-[40px] rounded-md border-l-[3px] border-[#F26522] bg-white/95 shadow-lg ring-1 ring-neutral-200 flex items-center px-2 text-[11px] text-neutral-700 truncate"
            >
              {i === 0 ? `${item.ion ?? ''} ${item.name}`.trim() : `Day ${i + 1}`}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
